import { axios, API } from './config';

export const categoriesAPI = {
  // Get all categories grouped by type
  getAll: async () => {
    const response = await axios.get(`${API}/categories/`);
    return response.data;
  },

  // Get categories by type
  getByType: async (type) => {
    const response = await axios.get(`${API}/categories/${type}`);
    return response.data;
  },

  // Create category
  create: async (data) => {
    const response = await axios.post(`${API}/categories/`, data);
    return response.data;
  },

  // Update category
  update: async (id, data) => {
    const response = await axios.put(`${API}/categories/${id}`, data);
    return response.data;
  },

  // Delete category
  delete: async (id) => {
    const response = await axios.delete(`${API}/categories/${id}`);
    return response.data;
  },

  // Seed default categories
  seedDefaults: async () => {
    const response = await axios.post(`${API}/categories/seed-defaults`);
    return response.data;
  }
};

export default categoriesAPI;
